import { createLogic, Logic } from 'redux-logic';
import { Observable } from 'rxjs';

import {
  actionTypes as appActionsTypes,
  actions as appActions,
} from 'reducer/app';
import { IUser, actions as userActions } from 'reducer/user';
import { actions as mapActions } from 'reducer/map';
import { actions as settingsActions } from 'reducer/settings';

import { getCurrentUser } from 'api/users';
import { IRootState }     from '../reducer';

const appLogic = createLogic({
  type: appActionsTypes.PERFORM_INITIAL_APP_LOADING,
  latest: false,
  warnTimeout: 0,

  async process(
    {
      getState,
      action$,
    }: { getState: () => IRootState; action$: Observable<{}> },
    dispatch,
    done
  ) {
    try {
      if (getState().user.isLogged) {
        await getCurrentUser().then((user: IUser) => {
          if (user) {
            if (user.mapSettings) {
              dispatch(mapActions.saveCurrentPosition({ settings: user.mapSettings }));
              dispatch(mapActions.changeCurrentPosition({ settings: user.mapSettings }));
            }
            if (user.settings) {
              dispatch(settingsActions.setSettings(user.settings));
            }
            dispatch(userActions.setUser(user));
          }
        });
      }
    } catch (e) {
    } finally {
      dispatch(appActions.finishInitializing());
    }
    done();
  },
});

export default [appLogic as Logic];
